import styled from "styled-components";

export const Container = styled.div`
    @import url('https://fonts.googleapis.com/css2?family=Andada+Pro&display=swap');

    * {
    font-family: "Andada Pro", serif;
  }

  button {
    font-family: "Andada Pro", serif;
    
    
  }
`;